import * as React from 'react'
import { SVGProps } from 'react'

const SvgUsdttIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 32 33' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <g clipPath='url(#USDTTIcon_svg__a)'>
      <path
        d='M28.82 19.17c-1.954 7.837-9.893 12.607-17.732 10.652C3.253 27.87-1.517 19.93.438 12.092 2.391 4.255 10.33-.515 18.166 1.439c7.838 1.954 12.607 9.893 10.653 17.732Z'
        fill='#1BA27A'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.482 17.289c-.104.008-.638.04-1.83.04-.949 0-1.622-.029-1.858-.04-3.665-.161-6.4-.8-6.4-1.563 0-.764 2.735-1.401 6.4-1.565v2.493c.24.017.925.057 1.874.057 1.138 0 1.707-.047 1.81-.057v-2.491c3.657.163 6.386.8 6.386 1.563 0 .762-2.728 1.4-6.386 1.562h.003Zm0-3.384v-2.23h5.103v-3.4H7.69v3.4h5.103v2.23c-4.148.19-7.267 1.011-7.267 1.996 0 .984 3.12 1.805 7.267 1.997v7.146h3.688v-7.15c4.138-.19 7.251-1.01 7.251-1.994s-3.11-1.804-7.251-1.996v.001Z'
        fill='#fff'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M25.6 21.114c-3.52 0-6.4-2.88-6.4-6.432.032-3.52 2.88-6.4 6.432-6.367A6.426 6.426 0 0 1 32 14.778a6.406 6.406 0 0 1-6.4 6.336'
        fill='#FC070C'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M29.572 12.797c-.297-.287-.61-.591-.886-.837l-.028-.02a.532.532 0 0 0-.156-.086l-.213-.04c-1.472-.275-6.243-1.165-6.341-1.153a.195.195 0 0 0-.082.03l-.026.022a.311.311 0 0 0-.073.118l-.007.018v.114c.324.903 1.165 2.917 1.942 4.777.657 1.572 1.268 3.034 1.481 3.62.028.088.081.253.18.261h.023c.053 0 .28-.3.28-.3s4.054-4.916 4.465-5.44c.053-.064.1-.134.14-.207a.337.337 0 0 0-.111-.314 34.387 34.387 0 0 1-.588-.563Zm-2.866 1.136 1.73-1.435 1.016.935-2.746.5Zm-3.651-2.535 2.98 2.441 1.84-1.553-4.82-.888Zm3.248 3.08 3.05-.49-3.487 4.2.437-3.71Zm-.518-.177-3.135-2.66 2.681 6.55.454-3.89Z'
        fill='#fff'
      />
    </g>
    <defs>
      <clipPath id='USDTTIcon_svg__a'>
        <path fill='#fff' d='M0 0h32v32.004H0z' />
      </clipPath>
    </defs>
  </svg>
)

export default SvgUsdttIcon
